import React, { useContext, useMemo } from 'react'
//import { v4 } from 'uuid'
import type { PageProps } from '../../pages/[[...path]]'

export type SwitcherLocalesProps = {
	pageLocales?: PageProps['pageLocales']
	currentLocaleCode?: PageProps['currentLocaleCode']
}

const defaultSwitcherLocalesValues: SwitcherLocalesProps = {
	currentLocaleCode: 'en',
	pageLocales: [
		{
			id: crypto.randomUUID(),
			locale: {
				code: 'en',
				label: 'English',
			},
			link: {
				url: '#',
			},
		},
	],
}

export const SwitcherLocalesContext = React.createContext<SwitcherLocalesProps | undefined>(defaultSwitcherLocalesValues)

export const SwitcherLocalesContextProvider: React.FunctionComponent<SwitcherLocalesProps & { children: React.ReactNode }> = ({
	children,
	...props
}) => {
	const sortedProps = useMemo(() => {
		if (!props.pageLocales) return props

		return {
			...props,
			pageLocales: [...props.pageLocales].sort((a, b) => {
				return (b.locale?.code || '').localeCompare(a.locale?.code || '')
			}),
		}
	}, [props])

	return <SwitcherLocalesContext.Provider value={sortedProps}>{children}</SwitcherLocalesContext.Provider>
}

export const useLocales = () => {
	const getLocales = useContext(SwitcherLocalesContext)
	return getLocales
}
